import { Route, Routes } from "react-router-dom";
import { Routing } from "../helper/paths";

export default function MainRoutes() {
  return (
    <Routes>
      {Routing.Public.map((e) => (
        <Route path={e.path} element={e.component} />
      ))}
    </Routes>
  );
};
